import { Label } from "../../../components/Label";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Radio } from "../../../components/Radio";
import { Icon } from "../../../components/core/Icon";
import { Hairline } from "../../../components/Hairline";
import * as uuid from 'uuid';

import styles from "../../../../styles/add-category.module.scss";
import { CurrencyInput } from "../../../components/CurrencyInput";

const getEmptyDough = (category) => ({ 
	name: '', 
	type: 'dough', 
	sizes: category.sizes, 
	ref_id: uuid.v4() 
});

const DoughItem = ({ dough, onChange, onDelete }) => {
	return (
		<>
			<div className="d-flex mb-15 mt-20">
				<Input
					design="four"
					floatLabel="Nome da massa"
					defaultValue={dough.name}
					onChange={(e) => onChange({ ...dough, name: e.target.value })}
					className="w-100"
				/>
				<Button
					design="default-icon-2"
					onClick={onDelete}
					className="ml-15"
				>
					<Icon name="trash-alt" size="lg" />
				</Button>
			</div>
			{
				dough.sizes.map((size, sizeIdx, sizes) => {
					return (
						<div className="d-flex mt-5">
							<div className={styles.stepName}>{size.name}</div>
							<CurrencyInput
								design="four"
								value={size.price}
								onChange={(e, m, f) => onChange({
									...dough,
									sizes: sizes.map((s, sIdx) => {
										if (sIdx == sizeIdx) {
											return { ...s, price: f }
										}
										return s;
									})
								})}
								placeholder="R$ 0,00"
								className="w-50"
							/>
						</div>
					)
				})
			}
		</>
	)
}

const SetPizzaDoughsStep = ({ category, onChange }) => {
	const handler = (e) => {
		onChange({ doughs: e });
	};

	const onDeleteDough = (doughIndex) => {
		handler(category.doughs.filter((e, dIdx) => dIdx != doughIndex))
	}

	return (
		<>
			<Label>Esta categoria possui variedade de massas?</Label>
			<Radio
				family="has-edges"
				value={false}
				checked={category.doughs.length > 0}
				className="mb-15"
				onChange={(value) => handler([])}
			>
				Não
			</Radio>
			<Radio
				family="has-edges"
				value={true}
				checked={category.doughs.length > 0}
				onChange={(value) => handler([getEmptyDough(category)])}
			>
				Sim
			</Radio>

			{category.doughs.length > 0 && (
				<>
					<Hairline />

					<Label>Quais são as massas?</Label>
					{category.doughs.map((d, dIdx, doughs) => {
						return (
							<>
								<DoughItem
									dough={d}
									onDelete={() => onDeleteDough(dIdx)}
									onChange={(newDough) => {
										doughs[dIdx] = newDough;
										handler(doughs);
									}}									
								/>
								{dIdx !== doughs.length - 1 && <Hairline />}
							</>
						)
					})}
					<Button design="default-2" className="mt-20" onClick={() => handler([...category.doughs, getEmptyDough(category)])}>
						Adicionar massa
					</Button>
				</>
			)}
		</>
	);
};

export default SetPizzaDoughsStep;
